export const ACTIVITY_HEADER_ID = "activity-header";
export const CAPACITY_PER_DAY_HEADER_ID = "capacity-perday-header";
export const DAYS_OFF_HEADER_ID = "daysoff-header";